export default "__VITE_ASSET__CiJFpxtE__"